const SalesChannels = ({ channel }) => {
  if (!channel || channel === 0) {
    return <span className="badge text-dark bg-info">none</span>;
  }

  const badges = [
    { bit: 1, label: "FBA", className: "bg-success" },
    { bit: 2, label: "FBM", className: "bg-warning" },
    { bit: 4, label: "eBay", className: "bg-danger" },
    { bit: 8, label: "Walmart", className: "bg-primary" },
    { bit: 16, label: "Other", className: "bg-pink" },
    { bit: 32, label: "Online Store", className: "bg-info" },
    { bit: 64, label: "Liquidations", className: "bg-secondary" },
  ];

  const active = badges.filter((b) => (channel & b.bit) === b.bit);

  if (!active.length) {
    return <span className="badge text-dark bg-info">none</span>;
  }

  return (
    <div className="d-flex flex-wrap gap-1 justify-content-space-between">
      {active.map((b) => (
        <span key={b.bit} className={`badge text-dark ${b.className}`}>
          {b.label}
        </span>
      ))}
    </div>
  );
};

export default SalesChannels;
